module.exports = __webpack_public_path__ + "static/hero_homepage-1cf2118b02e5ec84d449946c80e0e65a.jpg";